import { DataObject } from '../../models/report.model';
import { extractCompanies, PreprocessorCompanyContacts } from './preprocessor-company-contacts.interface';

export class PreprocessorCompanyContactsGeneral implements PreprocessorCompanyContacts {
  processCompanyContacts(record: DataObject): DataObject {
    return { ...record, company_contact_role_addresses: extractCompanies(record['company_contact_role_addresses']) };
  }
}
